// Echte Produkte von my.fancy-donuts.com
// Kategorien: Classics, Specials, Dossants, Potsdamer, Boxen, Vegan

export const donutProducts = [
  // CLASSICS (3€) - 8 Produkte
  {
    id: 'CL_001',
    name: 'König Krokant',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-89.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Krokant',
    vegan: true,
    description: 'Klassischer Donut mit dunkler Schokoladenglasur und knusprigem Krokant'
  },
  {
    id: 'CL_002',
    name: 'Proud Pistachio',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-86.png',
    basis: 'Donut (Groß)',
    glasur: 'Weiße Schokolade',
    topping: 'Pistazien',
    sauce: 'Dunkle Schokolade',
    vegan: false,
    description: 'Cremige weiße Schokolade mit gerösteten Pistazien'
  },
  {
    id: 'CL_003',
    name: 'Kindly Kidsriegel',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-14-1200px-21-12-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Kinderriegel, bunte Streusel, Erdbeere',
    sauce: 'Weiße Schokolade',
    vegan: false,
    description: 'Beliebter Kinderriegel mit bunten Streuseln und frischer Erdbeere'
  },
  {
    id: 'CL_004',
    name: 'Ore-Only',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-84.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Oreo, Oreo Crumbs',
    vegan: false,
    description: 'Schokoladiger Genuss mit Original Oreo Keksen'
  },
  {
    id: 'CL_005',
    name: 'Lovely Lotus',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-78.png',
    basis: 'Donut (Groß)',
    glasur: 'Lotus Biscoff Creme',
    topping: 'Lotus-Keks, Lotus-Keks-Crumbs',
    vegan: false,
    description: 'Karamellisierte Lotus-Keks Perfektion'
  },
  {
    id: 'CL_006',
    name: 'Sweet Sprinkles',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-4-1200px-16-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Rosa Schokolade',
    topping: 'Bunte Streusel',
    vegan: false,
    description: 'Klassisch bunter Donut mit rosa Glasur'
  },
  {
    id: 'CL_007',
    name: 'Sprinkles Choc',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-75.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Bunte Streusel',
    vegan: false,
    description: 'Dunkle Schokolade mit bunten Streuseln'
  },
  {
    id: 'CL_008',
    name: 'Choco Coco',
    category: 'Classics',
    price: 3.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0003_Fancy-Donuts-by-Jay-Adel-Donuts-150.png',
    basis: 'Donut (Groß)',
    glasur: 'Weiße Schokolade',
    topping: 'Raffaello, Kokosraspeln',
    vegan: false,
    description: 'Cremiger Kokos-Genuss mit Raffaello'
  },

  // SPECIALS (4€) - 9 Produkte
  {
    id: 'SP_001',
    name: 'Beautiful Brownie',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-7-1200px-21-12-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Brownie, Brownie-Crumbs',
    sauce: 'Weiße Schokolade',
    vegan: false,
    description: 'Schokoladiger Donut mit saftigem Brownie-Topping'
  },
  {
    id: 'SP_002',
    name: 'Bueno Boom',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-8-1200px-16-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Rosa Schokolade',
    topping: 'Erdbeere, Rosa Schokoladenraspeln, kinder bueno',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Premium Donut mit kinder bueno und Erdbeeren'
  },
  {
    id: 'SP_003',
    name: 'Coco Classic',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-15-1900px-23-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Weiße Schokolade',
    topping: 'Erdbeere, Raffaello, Kokosraspeln',
    filling: 'Vanille-Creme',
    vegan: false,
    description: 'Cremiger Kokos mit Raffaello und Vanille-Füllung'
  },
  {
    id: 'SP_004',
    name: 'Country Cool',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0020_Fancy-Donuts-by-Jay-Adel-Donuts-133.png',
    basis: 'Donut (Groß)',
    glasur: 'Weiße Schokolade',
    topping: 'kinder Country, Kellogg\'s Smacks',
    sauce: 'Weiße Schokolade',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Gefüllter Premiumdonut mit kinder Country und Smacks'
  },
  {
    id: 'SP_005',
    name: 'delicate Duplo',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-1-1900px-23-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Schokoladenraspeln, Duplo',
    sauce: 'Dunkle Schokolade',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Dreifach schokoladig mit Duplo'
  },
  {
    id: 'SP_006',
    name: 'Happy Hippo',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-11-1900px-23-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Weiße Schokolade',
    topping: 'Erdbeere, kinder Happy Hippo, Heidelbeeren, Weiße Schokoladenraspeln',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Fruchtig-cremiger Genuss mit kinder Happy Hippo'
  },
  {
    id: 'SP_007',
    name: 'Kitkit Kindness',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-6-1900px-23-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Dunkle Schokolade',
    topping: 'Himbeeren, Weiße Schokoladenraspeln, KitKat White',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Premium Donut mit KitKat White und Himbeeren'
  },
  {
    id: 'SP_008',
    name: 'Popcorn Power',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0032_Fancy-Donuts-by-Jay-Adel-Donuts-121.png',
    basis: 'Donut (Groß)',
    glasur: 'Karamell',
    topping: 'Popcorn, Karamellsauce',
    vegan: false,
    description: 'Süß-salziger Karamell-Popcorn-Genuss'
  },
  {
    id: 'SP_009',
    name: 'Toffi Tender',
    category: 'Specials',
    price: 4.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-15-1200px-16-02-2022.png',
    basis: 'Donut (Groß)',
    glasur: 'Karamell',
    topping: 'Toffifee, Karamellsauce',
    vegan: false,
    description: 'Zarter Karamell-Donut mit Toffifee'
  },

  // DOSSANTS (5€) - 9 Produkte
  {
    id: 'DO_001',
    name: 'Majestic Maccaron',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-23-1200px-21-12-2022.png',
    basis: 'Dossant',
    glasur: 'Rosa Schokolade',
    topping: 'Himbeeren, Rosa Schokoladenraspeln, Heidelbeeren, Maccaron',
    sauce: 'Weiße Schokolade',
    filling: 'Erdbeer-Fruchtsauce',
    vegan: false,
    description: 'Luxuriöser Croissant-Donut Hybrid mit Macarons und Beeren'
  },
  {
    id: 'DO_002',
    name: 'Pure Pistachio Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-37-1200px-21-12-2022.png',
    basis: 'Dossant',
    glasur: 'Weiße Schokolade',
    topping: 'Pistazien, Himbeeren, GiOTTO',
    sauce: 'Weiße Schokolade',
    filling: 'Pistazien-Creme',
    vegan: false,
    description: 'Pistaziencreme gefüllt mit knackigen Pistazien und GiOTTO'
  },
  {
    id: 'DO_003',
    name: 'Bueno Boom Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-35-1200px-21-12-2022.png',
    basis: 'Dossant',
    glasur: 'Haselnuss-Creme',
    topping: 'Erdbeere, kinder bueno White',
    filling: 'Haselnuss-Creme',
    vegan: false,
    description: 'Haselnuss-Traum mit kinder bueno White'
  },
  {
    id: 'DO_004',
    name: 'Grateful Giotto Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-34-1200px-21-12-2022.png',
    basis: 'Dossant',
    glasur: 'Haselnuss-Creme',
    topping: 'Krokant, Himbeeren, GiOTTO',
    filling: 'Nutella',
    vegan: false,
    description: 'Nutella-gefüllt mit GiOTTO und Krokant'
  },
  {
    id: 'DO_005',
    name: 'Holy Hazelnut Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-15-1200px-21-12-2022.png',
    basis: 'Dossant',
    glasur: 'Haselnuss-Creme',
    topping: 'Krokant',
    filling: 'Haselnuss-Creme',
    vegan: false,
    description: 'Purer Haselnuss-Genuss innen und außen'
  },
  {
    id: 'DO_006',
    name: 'Kids Surprise Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-3-1200px-21-12-2022.png',
    basis: 'Dossant',
    glasur: 'Braune Schokolade',
    topping: 'Krokant, GiOTTO, kinder Überraschungsei',
    sauce: 'Dunkle Schokolade',
    filling: 'Nutella',
    vegan: false,
    description: 'Überraschung! Mit Ü-Ei und Nutella-Füllung'
  },
  {
    id: 'DO_007',
    name: 'Lovely Lotus Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0043_Fancy-Donuts-by-Jay-Adel-Donuts-110.png',
    basis: 'Dossant',
    glasur: 'Lotus Biscoff Creme',
    topping: 'Lotus-Keks, Lotus-Keks-Crumbs, Himbeeren, Heidelbeeren',
    filling: 'Lotus Biscoff Creme',
    vegan: true,
    description: 'Veganer Lotus-Genuss mit Beeren'
  },
  {
    id: 'DO_008',
    name: 'Baklava Brilliant Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0055_Fancy-Donuts-by-Jay-Adel-Donuts-98.png',
    basis: 'Dossant',
    glasur: 'Weiße Schokolade',
    topping: 'Pistazien, Himbeeren, Baklava',
    sauce: 'Weiße Schokolade',
    filling: 'Pistazien-Creme',
    vegan: false,
    description: 'Orient-Traum mit Baklava und Pistazien-Füllung'
  },
  {
    id: 'DO_009',
    name: 'Strawberry Nutella Dossant',
    category: 'Dossants',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-22-1200px-16-02-2022.png',
    basis: 'Dossant',
    glasur: 'Weiße Schokolade',
    topping: 'Mandelsplitter, Erdbeere',
    filling: 'Nutella',
    vegan: false,
    description: 'Nutella-gefüllt mit frischen Erdbeeren'
  },

  // POTSDAMER (5€) - 11 Produkte (XXL Donuts)
  {
    id: 'PO_001',
    name: 'Baklava Brilliant Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0055_Fancy-Donuts-by-Jay-Adel-Donuts-98.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Weiße Schokolade',
    topping: 'Pistazien, Himbeeren, Baklava',
    sauce: 'Weiße Schokolade',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Orient-Traum XXL mit Baklava und Pistazien'
  },
  {
    id: 'PO_002',
    name: 'Beautiful Brownie Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-13-1200px-21-12-2022.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Dunkle Schokolade',
    topping: 'Brownie, Brownie-Crumbs',
    sauce: 'Weiße Schokolade',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Schokoladiger XXL Donut mit saftigem Brownie'
  },
  {
    id: 'PO_003',
    name: 'Berries Beauty Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0061_Fancy-Donuts-by-Jay-Adel-Donuts-92.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Rosa Schokolade',
    topping: 'Erdbeere, Himbeeren, Glitzerstaub, Rosa Schokoladenraspeln, Heidelbeeren',
    filling: 'Mehrfrucht-Sauce',
    vegan: false,
    description: 'Beerenzauber mit Glitzer in XXL'
  },
  {
    id: 'PO_004',
    name: 'Bold Bueno Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-8-1200px-16-02-2022.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Rosa Schokolade',
    topping: 'Erdbeere, Rosa Schokoladenraspeln, kinder bueno',
    filling: 'Mehrfrucht-Sauce',
    vegan: false,
    description: 'Kinder Bueno in XXL Größe'
  },
  {
    id: 'PO_005',
    name: 'Charming Cheesecake Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-22-1200px-21-12-2022.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Weiße Schokolade',
    topping: 'Erdbeere, Schokoladenraspeln, Käsekuchen, Weiße Schokoladenraspeln',
    sauce: 'Weiße Schokolade',
    filling: 'Boston-Creme',
    vegan: false,
    description: 'Cheesecake trifft auf XXL Donut'
  },
  {
    id: 'PO_006',
    name: 'Grateful Giotto Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-2023-24-1200px-21-12-2022.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Dunkle Schokolade',
    topping: 'Himbeeren, Schokoladenraspeln, GiOTTO, Weiße Schokoladenraspeln',
    sauce: 'Weiße Schokolade',
    filling: 'Boston-Creme',
    vegan: false,
    description: 'GiOTTO in XXL mit Boston-Creme'
  },
  {
    id: 'PO_007',
    name: 'Juicy Joy Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/30-Juicy-Joy.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Dunkle Schokolade',
    topping: 'Krokant, Himbeeren, kinder Joy, kinder Happy Hippo',
    sauce: 'Weiße Schokolade',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Joy und Happy Hippo vereint in XXL'
  },
  {
    id: 'PO_008',
    name: 'Magic King Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0048_Fancy-Donuts-by-Jay-Adel-Donuts-105.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Dunkle Schokolade',
    topping: 'Krokant, kinder Maxi King',
    sauce: 'Weiße Schokolade',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'XXL Potsdamer mit kinder Maxi King'
  },
  {
    id: 'PO_009',
    name: 'Ore-Obsession Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-7-1900px-23-02-2022.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Dunkle Schokolade',
    topping: 'Erdbeere, Oreo, Oreo Crumbs',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Oreo-Overload in XXL Format'
  },
  {
    id: 'PO_010',
    name: 'Pretty Pingu Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-25-1200px-16-02-2022_0053_Fancy-Donuts-by-Jay-Adel-Donuts-100.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Weiße Schokolade',
    topping: 'Erdbeere, Schokoladenraspeln, kinder Pinguí',
    sauce: 'Dunkle Schokolade',
    filling: 'Boston-Creme',
    vegan: false,
    description: 'Pinguí trifft auf cremige Boston-Füllung'
  },
  {
    id: 'PO_011',
    name: 'White Milk Potsdamer',
    category: 'Potsdamer',
    price: 5.00,
    image: 'https://my.fancy-donuts.com/wp-content/uploads/2024/04/Fancy-Donuts-by-Jay-Adel-Donuts-12-1900px-23-02-2022.png',
    basis: 'Potsdamer (XXL)',
    glasur: 'Weiße Schokolade',
    topping: 'Himbeeren, Weiße Schokoladenraspeln, Milch-Schnitte',
    filling: 'Dunkle Schokolade',
    vegan: false,
    description: 'Milch-Schnitte auf XXL Format'
  }
];

export const extras = [
  { id: 'coffee', name: 'Kaffee-Paket', description: '10 Tassen Premium Kaffee', price: 15.00 },
  { id: 'dips', name: 'Dip-Auswahl', description: 'Schokolade, Karamell, Erdbeer', price: 8.00 },
  { id: 'card', name: 'Personalisierte Karte', description: 'Mit individueller Nachricht', price: 3.00 },
  { id: 'branding', name: 'Firmen-Branding', description: 'Logo-Sticker auf Box', price: 12.00 }
];

export const deliveryIntervals = [
  { id: 'once', name: 'Einmalig', description: 'Einmalige Lieferung', discount: 0 },
  { id: 'weekly_1', name: 'Einmal wöchentlich', description: 'Flexibler Liefertag', discount: 5 },
  { id: 'weekly_2', name: 'Zweimal wöchentlich', description: 'Zwei Liefertage pro Woche', discount: 10 },
  { id: 'monthly_1', name: 'Einmal monatlich', description: 'Einmal pro Monat', discount: 3 },
  { id: 'custom', name: 'Individuell', description: 'Dein eigener Rhythmus', discount: 0, isCustom: true }
];

export const testimonials = [
  {
    name: 'Marc R.',
    company: 'Tech Startup Berlin',
    text: 'Es gibt eine große Auswahl an sehr leckeren Donuts, die Wahl fällt einem echt schwer. Das Team war begeistert!',
    rating: 5
  },
  {
    name: 'Stefanie S.',
    company: 'Marketing Agentur München',
    text: 'Mega leckere Donuts. Die Lieferung war pünktlich und das Personal ist sehr freundlich. Wir bestellen regelmäßig für unser Team.',
    rating: 5
  },
  {
    name: 'Erkan A.',
    company: 'Consulting Firm Frankfurt',
    text: 'Vorneweg eine echt nette freundliche Bedienung. Die Donuts selber sind sehr lecker gewesen, man konnte sie regelrecht auf der Zunge zergehen lassen.',
    rating: 5
  },
  {
    name: 'Sina Weber',
    company: 'Design Studio Hamburg',
    text: 'Hier gibt es super leckere Donuts mit kreativen Füllungen und Toppings. Diese gehören definitiv mit zu den Besten. Preis-Leistung absolut top!',
    rating: 5
  },
  {
    name: 'Jane F.',
    company: 'E-Commerce Köln',
    text: 'Sehr schön dekorierte Boxen mit super leckeren Donuts. Die Donuts sind immer frisch und die Abwicklung immer reibungslos.',
    rating: 5
  }
];

export const faqs = [
  {
    question: 'Was ist die Mindestbestellmenge?',
    answer: 'Die Mindestbestellmenge beträgt 6 Donuts (1 Box). Ideal für kleine Teams ab 3-5 Personen.'
  },
  {
    question: 'Welche Allergene sind enthalten?',
    answer: 'Die meisten unserer Donuts enthalten Gluten und Milchprodukte. Spezifische Allergene wie Nüsse, Soja oder Ei sind bei jedem Produkt einzeln aufgeführt. Wir bieten auch vegane Optionen wie König Krokant und Lovely Lotus Dossant an.'
  },
  {
    question: 'In welche Gebiete liefern Sie?',
    answer: 'Wir liefern deutschlandweit in alle Großstädte und Ballungsgebiete. Die Lieferung erfolgt täglich frisch am Morgen zwischen 7-9 Uhr.'
  },
  {
    question: 'Wie kann ich mein Abo kündigen?',
    answer: 'Abos können jederzeit mit einer Vorlaufzeit von 3 Werktagen gekündigt werden. Einfach per E-Mail oder über Ihr Kundenportal.'
  },
  {
    question: 'Erhalte ich eine Rechnung für meine Firma?',
    answer: 'Ja, natürlich! Sie erhalten automatisch eine ordnungsgemäße Rechnung mit ausgewiesener MwSt. per E-Mail nach jeder Lieferung.'
  },
  {
    question: 'Wie lange im Voraus muss ich bestellen?',
    answer: 'Für Erstbestellungen benötigen wir mindestens 2 Werktage Vorlaufzeit. Bei bestehenden Abos können Sie die Auswahl bis 18 Uhr am Vortag ändern. Express-Lieferung (Same-Day) ist bei Bestellung bis 10 Uhr möglich.'
  }
];

export const companyLogos = [
  { name: 'ARD', image: 'https://fancy-donuts.com/wp-content/uploads/2022/02/ARD_logo.png' },
  { name: 'RBB', image: 'https://fancy-donuts.com/wp-content/uploads/2022/02/2000px-Rbb_Logo_2017.08.svg.png' },
  { name: 'YouTube', image: 'https://fancy-donuts.com/wp-content/uploads/2022/02/502px-Logo_of_YouTube_2015-2017.svg.png' }
];

// Preisberechnung
export const calculatePrice = (teamSize, boxCount, interval, selectedExtras) => {
  const donutsPerBox = 6;
  const pricePerDonut = 3.5; // Durchschnittspreis
  const deliveryFee = boxCount < 5 ? 9.99 : 0;
  
  const donutsTotal = boxCount * donutsPerBox * pricePerDonut;
  const extrasTotal = selectedExtras.reduce((sum, extra) => sum + extra.price, 0);
  
  const intervalData = deliveryIntervals.find(i => i.id === interval) || deliveryIntervals[0];
  const discount = (donutsTotal * intervalData.discount) / 100;
  
  const subtotal = donutsTotal + extrasTotal;
  const total = subtotal - discount + deliveryFee;
  
  return {
    donutsTotal,
    extrasTotal,
    subtotal,
    discount,
    deliveryFee,
    total
  };
};
